var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 90,
    viewBox: "0 0 91 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.3994,
    cy: 45,
    r: 44,
    fill: "white",
    stroke: "#B9D7FF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.672 54.1549V65.5932C72.672 69.3839 69.5997 72.4562 65.809 72.4562H54.3706C47.6105 72.4562 41.7083 68.7617 38.5399 63.2964L38.6314 63.2049C51.8702 62.1937 62.5834 52.3522 63.4573 39.953C63.4962 39.4177 63.4801 38.8869 63.4847 38.3539L63.5145 38.3242C68.9797 41.4926 72.672 47.3948 72.672 54.1549Z",
    fill: "#4A90E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2722 23.5757C49.0561 19.3572 43.2088 17.1634 37.2265 17.598C26.8725 18.3301 18.1267 28.0435 18.1267 38.8116V50.3369C18.1267 54.9603 21.8831 58.7235 26.5019 58.7235H36.7438C48.61 58.7235 58.4973 50.3346 59.2522 39.6237C59.6754 33.646 57.4953 27.7965 53.2745 23.5734L53.2722 23.5757ZM38.7158 50.7167C37.1373 50.7167 35.8562 49.4356 35.8562 47.8571C35.8562 46.2786 37.1373 44.9975 38.7158 44.9975C40.2943 44.9975 41.5754 46.2786 41.5754 47.8571C41.5754 49.4356 40.2943 50.7167 38.7158 50.7167ZM42.026 39.5734C41.0034 40.1362 41.0034 40.3009 41.0034 40.4221C41.0034 41.6872 39.9786 42.7098 38.7158 42.7098C37.453 42.7098 36.4281 41.6872 36.4281 40.4221C36.4281 37.4299 38.8027 36.1236 39.8161 35.5654C40.4796 35.2017 41.1773 34.3415 40.9646 33.1267C40.8067 32.23 40.0449 31.4682 39.1504 31.3126C38.4504 31.1845 37.7732 31.3629 37.2471 31.8068C36.7255 32.2414 36.4281 32.882 36.4281 33.5614C36.4281 34.8265 35.4032 35.8491 34.1404 35.8491C32.8776 35.8491 31.8527 34.8265 31.8527 33.5614C31.8527 31.5277 32.7472 29.6106 34.3051 28.302C35.863 26.9935 37.9128 26.4399 39.9397 26.8082C42.7055 27.2909 44.9817 29.5648 45.469 32.3375C45.9791 35.2474 44.5951 38.1551 42.0237 39.5757L42.026 39.5734Z",
    fill: "#00226F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/FAQ.6ae28c88d376c2faf45de0210a3d85ea.svg";
export { ForwardRef as ReactComponent };